import axios from 'axios'
import authHeader from '../security/auth.header'

const API_URL = process.env.VUE_APP_BASE_API_URL + '/api/v1/super-admin'

class SuperAdminApi {
  deleteUser(data) {
    return axios.delete(API_URL + '/user/_delete', { data: data, headers: authHeader() })
  }

  getSignUpList(page, size, filter) {
    let filterString = ''
    for (const key in filter) {
      filterString += '&filter[' + filter[key].field + ']=' + encodeURIComponent(filter[key].value)
    }
    return axios.get(API_URL + '/sign-up?actualPage=' + page + '&perPage=' + size + filterString, {
      headers: authHeader()
    })
  }

  getSignUpDetail(uuid) {
    return axios.get(API_URL + '/sign-up/' + uuid, {
      headers: authHeader()
    })
  }

  editSignUpData(uuid, data) {
    return axios.put(API_URL + '/sign-up/' + uuid, data, { headers: authHeader() })
  }

  approveRequest(uuid, data) {
    return axios.put(API_URL + '/sign-up/' + uuid + '/_process', data, { headers: authHeader() })
  }

  rejectRequest(uuid) {
    return axios.delete(API_URL + '/sign-up/' + uuid + '/_process', { headers: authHeader() })
  }
}

export default new SuperAdminApi()
